module.exports = __webpack_public_path__ + "img/coin-left.10b4515.png";